// extracted by mini-css-extract-plugin
module.exports = {"copy":"CopyButton_copy__2IbE5"};